import React, { useEffect, useState } from 'react';
import {
  Card,
  Confirm,
  Dimmer,
  Header,
  Loader,
  Segment,
  Container,
} from "semantic-ui-react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router";
import { useAgeReadyContext } from "../../AgeReadyContext/AgeReadyContext";
import { PartnerCodeStep } from "./PartnerCodeStep";
import styles from './Questionnaire.style.module.css';

export const NewMemberForm: React.FC = () => {
  const history = useHistory();
  const { caregiverStore } = useAgeReadyContext();
  const [isLoading] = useState<boolean>(false);
  const [groupCode, setgroupCode] = useState<string>('');
  const [onConfirmLoading, setOnConfirmLoading] = useState<boolean>(false);
  const [onCancelLoading, setOnCancelLoading] = useState<boolean>(false);

  useEffect(() => {
    caregiverStore.setPartnerCode('');
  }, [caregiverStore]);

  const saveClickHandler = async () => {
    caregiverStore.setPartnerCode(groupCode);
    const userInfo = await Auth.currentAuthenticatedUser()
    await caregiverStore.savePartnerCodeToCaregiver(userInfo.attributes.sub, groupCode);
  };

  const onConfirm = async () => {
    setOnConfirmLoading(true);
    try {
      history.push('/add-recipient');
      await saveClickHandler();
    } catch (e) {
      throw e;
    } finally {
      setOnConfirmLoading(false);
    }
  };

  const onConfirmCancel = async () => {
    setOnCancelLoading(true);
    try {
      history.push('/home');
      await saveClickHandler();
    }
    catch (e) {
      throw e;
    } finally {
      setOnCancelLoading(false)
    }
  };

  const confirmContent = () => (
    <>
      <Card.Header className={styles['segment-ui-header']}>
        <div style={{ display: 'inline' }} className={styles['segment-ui']}>
          <Container
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingBottom: 0,
            }}
          >
            <Header style={{ paddingBottom: 15, paddingTop: 20 }}>Would you like to add an AgeReady Profile now?</Header>
            <Header.Subheader style={{ fontSize: ".8em", paddingBottom: 20 }}>An AgeReady Profile could be a person you're caring for or even yourself.</Header.Subheader>
            <Header.Subheader style={{ fontSize: ".8em", paddingBottom: 20 }}>If you're not ready to add an AgeReady Profile, you can always add one at a later time.</Header.Subheader>
          </Container>
        </div>
      </Card.Header>
    </>
  );


  return (
    <Segment
      className={styles['segment-ui']}
      basic
      style={{
        borderRadius: '20px',
        padding: 0,
        marginTop: 30,
        marginBottom: 30
      }}
    >
      <Dimmer active={isLoading}>
        <Loader data-testid='saveLoader' />
      </Dimmer>

      {groupCode === '' && (
        <PartnerCodeStep
          onSave={(newgroupCode: string) => {

            setgroupCode(newgroupCode);
          }}
        />
      )}

      {(groupCode !== '') && (
        <>
          <Confirm
            open={true}
            confirmButton={{ content: "Yes", loading: onConfirmLoading }}
            cancelButton={{ content: "No", loading: onCancelLoading }}
            onConfirm={onConfirm}
            onCancel={onConfirmCancel}
            content={confirmContent}
          />
        </>
      )}
    </Segment>
  );
};
